const DIMENSIONS = { square: [1080, 1080], story: [1080, 1920] };

function roundedRect(ctx, x, y, width, height, radius) {
  const r = Math.min(radius, width / 2, height / 2);
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + width, y, x + width, y + height, r);
  ctx.arcTo(x + width, y + height, x, y + height, r);
  ctx.arcTo(x, y + height, x, y, r);
  ctx.arcTo(x, y, x + width, y, r);
  ctx.closePath();
}
function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });
}

function drawCover(ctx, image, width, height) {
  const scale = Math.max(width / image.width, height / image.height);
  const sourceWidth = width / scale;
  const sourceHeight = height / scale;
  ctx.drawImage(image, (image.width - sourceWidth) / 2, (image.height - sourceHeight) / 2, sourceWidth, sourceHeight, 0, 0, width, height);
}

function formatMinutes(minutes) {
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  return remainder ? `${hours}h ${remainder}m` : `${hours}h`;
}

export async function renderFlexCanvas(canvas, { category, badge, photo, format = "square", transparent = false }) {
  const [width, height] = DIMENSIONS[format] || DIMENSIONS.square;
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, width, height);

  if (!transparent) {
    if (photo) {
      try { drawCover(ctx, await loadImage(photo), width, height); } catch { /* use fallback below */ }
    }
    if (!photo) {
      const gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, "#090909");
      gradient.addColorStop(0.55, "#20170a");
      gradient.addColorStop(1, "#080808");
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);
    }
    const shade = ctx.createLinearGradient(0, height * 0.25, 0, height);
    shade.addColorStop(0, "rgba(0,0,0,0.02)");
    shade.addColorStop(1, "rgba(0,0,0,0.72)");
    ctx.fillStyle = shade;
    ctx.fillRect(0, 0, width, height);
  }

  const margin = 72;
  const cardHeight = format === "story" ? 560 : 500;
  const cardY = height - cardHeight - margin;
  roundedRect(ctx, margin, cardY, width - margin * 2, cardHeight, 42);
  ctx.fillStyle = transparent ? "rgba(8,8,8,0.90)" : "rgba(8,8,8,0.78)";
  ctx.fill();
  ctx.strokeStyle = "rgba(245,158,11,0.55)";
  ctx.lineWidth = 3;
  ctx.stroke();

  let asset = null;
  try { asset = await loadImage(`/badges/${category.key}.png`); } catch { /* monogram fallback */ }
  const badgeX = margin + 46;
  const badgeY = cardY + 42;
  if (asset) {
    ctx.drawImage(asset, badgeX, badgeY, 138, 138);
  } else {
    ctx.beginPath(); ctx.arc(badgeX + 69, badgeY + 69, 69, 0, Math.PI * 2);
    ctx.fillStyle = "#F59E0B"; ctx.fill();
    ctx.fillStyle = "#090909"; ctx.font = "700 58px Georgia"; ctx.textAlign = "center"; ctx.textBaseline = "middle";
    ctx.fillText(category.label.slice(0, 1).toUpperCase(), badgeX + 69, badgeY + 72);
  }

  ctx.textAlign = "left"; ctx.textBaseline = "alphabetic";
  ctx.fillStyle = "#F59E0B"; ctx.font = "600 24px Arial";
  ctx.fillText(badge.label.toUpperCase(), badgeX + 170, cardY + 77);
  ctx.fillStyle = "#F7F5EF"; ctx.font = "700 56px Georgia";
  ctx.fillText(category.label, badgeX + 170, cardY + 139);

  const stats = [
    [String(category.verifiedCount), "VERIFIED"],
    [formatMinutes(category.verifiedMinutes), "VERIFIED TIME"],
    [String(category.streakDays), "DAY STREAK"],
  ];
  const statsY = cardY + 264;
  const cellWidth = (width - margin * 2 - 92) / 3;
  stats.forEach(([value, label], index) => {
    const x = margin + 46 + index * cellWidth;
    ctx.fillStyle = "#F7F5EF"; ctx.font = "700 45px Arial"; ctx.fillText(value, x, statsY);
    ctx.fillStyle = "#A1A1AA"; ctx.font = "600 17px Arial"; ctx.fillText(label, x, statsY + 34);
  });
  ctx.fillStyle = "#F7F5EF"; ctx.font = "600 22px Arial";
  ctx.fillText(`${category.last30Verified} verified in the last 30 days`, margin + 46, cardY + cardHeight - 65);
  ctx.textAlign = "right"; ctx.fillStyle = "#F59E0B"; ctx.font = "700 22px Georgia";
  ctx.fillText("HustlrMate", width - margin - 46, cardY + cardHeight - 65);
}

export function canvasBlob(canvas) {
  return new Promise((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("Could not create image")), "image/png"));
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url; anchor.download = filename; anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
